import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import {Grid} from '@mui/material';
import { APIError } from '~common/lib/types';
import * as request from 'superagent';
import {TextField, FormControl, InputLabel, FormHelperText} from '@mui/material';
import BooleanField from '~common/components/boolean-field'
import {IconButton} from '~common/components/confirmation-button';
import AutoSuggest, {AutoSuggestQuery} from '~common/components/autosuggest';
import DateField from '~common/components/date-field';

import * as moment from 'moment';

const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	},
	paper: {
		padding: 30
	},
	heading: {
		marginTop: 30,
		borderBottom: '1px solid #ccc'
    },
    headerPaper: {
		padding: 30
    },
    root: {
		width: '100%'
	},
	formField: {
		width: '100%'
	},
	admintoolbar: {
		justifyContent: 'flex-end'
	},
	textField: {
		width: "100%"
    },
    headerTitle: {
        marginBottom: 10
	},
	booleanField: {
		width: "100%"
	},
	deleteIcon: {
		marginRight: 10,
		marginBottom: 20
    },
    proxyUserFullName: {
        width: "100%",
    },
    switchClass: {
        width: 100,
    },
    approvalRoutes: {
        width: 100,
    },
    searchField: {
        width: "100%",
    },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
    userType: string;
    proxy: any;
    proxies: Array<any>;
    features: Array<any>;
    key: any;
    idx: any;
    onProxyChange: (proxy: any)=>void;
}

type State = {

};

class ProxyFeatureAssignmentView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	_validationErrors: Array<any>;
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
           
		};
        
	}

	componentDidMount() {
    
    }

    fetchSuggestions = (resource: string, optionKey: string) => (query: AutoSuggestQuery):  Promise<any> => {
        return new Promise((resolve, reject) => {
            request.get(`/api${resource}${query.value}&userType=${this.props.userType || ''}&proxyForID=${this.props.proxy.portalUserID}`).then((response: request.Response)=>{
                if (!response.ok) {
                    const apiErr = new APIError()
                    apiErr.type = "api"
                    apiErr.message = "Error fetching data"
                    apiErr.details = response.body.toString()
                    reject(apiErr)
                }
                if (response.body.results && response.body.results.length > 0) {
                    
                    response.body.results = response.body.results.filter((i: any)=>{
                    
                        var exists = this.props.proxies.find((p: any)=>{
                            return p.proxyToUserID == i["id"]
                        })
                        return !exists
                    })

                    resolve(response.body.results.map((i: any)=>{
                        var label = `${i["firstName"]} ${i["lastName"]}`
                        if (i["employeeID"]) {
                            label = `${i["firstName"]} ${i["lastName"]} (${i["employeeID"]})`
                        }
                        return {label: label, value: i["id"]}
                    }))
                    
                } else {
                    resolve([])
                }
            }).catch((err)=>{
                const apiErr = new APIError()
                apiErr.type = "http"
                apiErr.message = "Error fetching data"
                apiErr.details = (err.response || {text: err.toString()}).text
                reject(apiErr)
            })
        });
    }

    onProxyUserSelect = (attr: any) => (event: any, data: any) => {
        // console.log("onProxyUserSelect", attr, data)
        if (data && data.suggestionValue && Object.keys(data.suggestionValue || {}).length > 0) {
            if (data.suggestionValue.value) {

                // attr.value = data.suggestionValue.value

                var {proxy} = this.props

                proxy.extendedAttributes["proxyUserFullName"] = data.suggestionValue.label
                proxy.proxyToUserID = data.suggestionValue.value

        
                this.setState({})

            } else  {
                // attr.value = undefined

                var {proxy} = this.props

                delete proxy.extendedAttributes["proxyUserFullName"]
                delete proxy.proxyToUserID

                this.setState({})

            }
        } else {
            if (data.suggestionValue) {
                this.setState({})
            }
        }
    }

    handleBlur = (key: any): any => (val: number | undefined): void => {

	}

    handleDateAttributeChange = (fieldKey: string): any => (event: any | undefined): void => {
        if (event) {
            var {proxy} = this.props
            proxy[fieldKey] = event
            this.props.onProxyChange(proxy)
            
        } else {
            var {proxy} = this.props
            proxy[fieldKey] = undefined
            this.props.onProxyChange(proxy)
        }
    };
    
    handleProxyFeatureToggle = (featureKey: string) => (event: any) => {
        // console.log("handleProxyFeatureToggle", featureKey)
        var value = this.getProxyFeatureValue(featureKey)
        var {proxy} = this.props
        if (!proxy.extendedAttributes["features"]) {
            proxy.extendedAttributes["features"] = []
        }
        var features = proxy.extendedAttributes["features"]
        // console.log("looking in these features", features)
        var idx = features.findIndex((f: any)=>{return f.featureKey == featureKey})
        // console.log("idx", idx)
        if (idx > -1) {
            if (value == true) {
                features[idx].extendedAttributes["_delete"] = true
            } else {
                delete features[idx].extendedAttributes["_delete"]
            }
        } else {
            features.push({
                portalUserProxyID: proxy.id,
                featureKey: featureKey,
                extendedAttributes: {}
            })
        }
        this.props.onProxyChange(proxy)
    }

    handleProxyReadOnlyToggle = (featureKey: string) => (event: any) => {
        // console.log("handleProxyReadOnlyToggle", event.target.value)
        var {proxy} = this.props
        proxy.readOnly = event.target.value
        this.props.onProxyChange(proxy)
    }

    getProxyFeatureValue = (featureKey: string) => {
        var {proxy} = this.props
        var features = proxy.extendedAttributes["features"]   
        if (features && features.find((f: any)=>{return !f.extendedAttributes["_delete"] && (f.featureKey == featureKey)})) {
            return true
        }
        return false
    }

    removeProxy = () => {
        // ATTENTION - just set _delete in the extendedAttributes, the handler will be responsible for deleteing the record.
        var {proxy} = this.props
        proxy.extendedAttributes["_delete"] = true
        this.props.onProxyChange(proxy)
    }

   
    
	render() {
		const { proxy, features} = this.props
		const { classes }: { classes: ClassNameMap } = this.props;
        
		return (
			<Grid key={this.props.key} style={{backgroundColor: (this.props.idx % 2) == 1 ?  "#eaeaea" : 'default', borderBottom: "1px solid #eee", display: proxy.extendedAttributes["_delete"] ? 'none' : '', marginTop: 0}} container spacing={4}>
                                    
                {proxy.id && <Grid item  xl={3} lg={3} md={3} sm={3} xs={3}>
                    <TextField
                        label={"Proxy User"}
                        className={classes.proxyUserFullName}
                        InputLabelProps={{
                            shrink: true
                        }}
                        disabled={true}
                        value={proxy.extendedAttributes["proxyUserFullName"] || ''}
                    />

                </Grid>}

                {!proxy.id && <Grid item  xl={3} lg={3} md={3} sm={3} xs={3}><FormControl className={classes.searchField}>
                    <InputLabel error={proxy._proxyToUserIDMissing ? true : false}  shrink className={classes.searchFieldLabel} required={true}>{"Proxy User"}</InputLabel>
                    <InputLabel  shrink className={classes.searchFieldLabel} required={true}>{"Proxy User"}</InputLabel>
                    <AutoSuggest
                        displayClearAdornment={true}
                        emitClear={true}
                        maxHeight={200}
                        name="proxyUser"
                        minQueryChars={3}
                        preventBusyTab={true}
                        autoSelectOptions={false}
                        classes={{}}
                        placeholder=""
                        value={proxy.extendedAttributes["proxyUserFullName"] || ""}
                        fetchSuggestions={this.fetchSuggestions("/portal-user-proxy/search-users?status=Active&term=", "proxyUser")}
                        onSuggestionSelected={this.onProxyUserSelect(proxy.proxyToUserID)}
                        disabled={false}
                    >
                    </AutoSuggest>
                    <FormHelperText style={{color: 'red'}}>{proxy._proxyToUserIDMissing ? "This field is required" : ''}</FormHelperText>
                </FormControl></Grid>}

                {<Grid item  xl={3} lg={3} md={3} sm={3} xs={3}><DateField
                    InputLabelProps={{shrink: true}}
                    className={classes.startDate}
                    classes={{}}
                    minDate={new Date()}
                    required={false}
                    value={proxy.startAt || ""}
                    label={"Start"}
                    onChange={this.handleDateAttributeChange("startAt")}
                    onBlur={this.handleBlur(proxy)}
                    error={false}
                    disabled={false}
                    autoOk={true}
                /></Grid>}

                {<Grid item  xl={3} lg={3} md={3} sm={3} xs={3}><DateField
                    InputLabelProps={{shrink: true}}
                    className={classes.startDate}
                    classes={{}}
                    minDate={new Date()}
                    required={false}
                    value={proxy.stopAt || ""}
                    label={"End"}
                    onChange={this.handleDateAttributeChange("stopAt")}
                    onBlur={this.handleBlur(proxy.stopAt)}
                    error={false}
                    disabled={false}
                    autoOk={true}
                /></Grid>}

                {/* <Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
                    <BooleanField
                        classes={{}}
                        // className={classes.switchClass}
                        presentAs="Routes"
                        onBooleanChange={this.handleProxyReadOnlyToggle( ("") )}
                        handleBlur={this.handleBlur}
                        value={proxy.readOnly.value || ""}
                        required={false}
                        label={"Disallow Updates?"}
                        disabled={this.props.disabled}
                    >
                    </BooleanField> 
                </Grid> */}

                <Grid item  xl={3} lg={3} md={3} sm={3} xs={3}>
                    <div style={{float: "right"}}>
                        <IconButton size="large" style={{height:40}} tabIndex={-1}  confirmColor="danger" classes={{}} color="primary"  onButtonConfirm={this.removeProxy.bind(this)}>
                            <i className="fa fa-xs fa-trash" />
                        </IconButton>    
                    </div>
                </Grid>
                
                
               
                            
                {features.map((f: any, idx)=>{
                    return (
                        <Grid key={idx} item xl={4} lg={3} md={3} sm={2} xs={2}>
                            <BooleanField
                                classes={{}}
                                // className={classes.switchClass}
                                presentAs="Switch"
                                onBooleanChange={this.handleProxyFeatureToggle( (f.key || "") )}
                                handleBlur={this.handleBlur}
                                value={this.getProxyFeatureValue(f.key || "")}
                                required={false}
                                label={f.title || ""}
                                disabled={this.props.disabled}
                            >
                            </BooleanField> 
                        </Grid>
                    )
                })}

            </Grid>
		);
	}
}

export default withStyles(styles)(ProxyFeatureAssignmentView);



